import { ApiError } from "components";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { FormDataValidation } from "./components/FormDataValidation";
import { CreateSpecialOfferInput,  SpecialOfferInputError, SpecialOfferProps, stateStatusType } from "../state/actionType";
import SpecialOfferForm from "./form/SpecialOfferForm";
import { resetSpecialOffer, updateSpecialOffer } from "../state/action";

interface OwnProps {
  specailOfferData: SpecialOfferProps;
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateSpecialOffer: React.FC<Props> = ({
  specailOfferData,
  onClose,
  onResetSpecialOffer,
  onUpdateFeaturedAds,
}) => {
  const specialOfferState = useSelector(
    (state: any) => state.fetchSpecialOfferReducer.genericSpecialOfferState
  );
  const formatDateToMMDDYYYY = (dateStr?: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<CreateSpecialOfferInput>({
    title: specailOfferData?.title,
    status: specailOfferData?.status,
    description: specailOfferData?.description,
    start_date: formatDateToMMDDYYYY(specailOfferData?.start_date),
    package_id:specailOfferData?.membership_duration?.package?.id,
    end_date: formatDateToMMDDYYYY(specailOfferData?.end_date),
    number_of_days: specailOfferData?.number_of_days,
    membership_duration_id: specailOfferData?.membership_duration?.id,

  });
  const [formError, setFormError] = useState<SpecialOfferInputError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "featured_order" ? Number(value) : value,
    }));
    setFormError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    const validationErrors = FormDataValidation(formData);
    if (Object.keys(validationErrors).length > 0) {
      setFormError(validationErrors);
      return;
    }
    setLoading(true);
    const input: CreateSpecialOfferInput = {
      title: formData.title,
      description: formData.description,
      status: formData.status,
      start_date: formData.start_date,
      end_date: formData.end_date,
      membership_duration_id: formData.membership_duration_id,
      number_of_days: formData.number_of_days
    };

    if (
      formData.title.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.start_date.trim() !== "" &&
      formData.end_date.trim() !== "" &&
      formData.status.trim() !== "" &&
      String(formData.number_of_days).trim() !== "" &&
      String(formData.membership_duration_id).trim() !== ""
    ) {
      const special_offer_id = specailOfferData?.id?.toString();
      onUpdateFeaturedAds(input, special_offer_id);
      setSubmitted(true);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (!specialOfferState.isLoading && submitted) {
      if (specialOfferState.error) {
        setApiError(specialOfferState.error);
      } else if (
        specialOfferState.status === stateStatusType.SUCCESS 
      ) {
        onClose();
        onResetSpecialOffer();
      } else {
        setApiError(null);
      }
    }
  }, [
    specialOfferState.isLoading,
    specialOfferState.error,
    specialOfferState.status,
    submitted,
  ]);
  useEffect(() => {
  if (specialOfferState.status === stateStatusType.SUCCESS && submitted) {
    onClose();
    onResetSpecialOffer();
  }
}, [specialOfferState.status, submitted,]);

  useEffect(() => {
    onResetSpecialOffer();
  }, []);
  return (
    <>
      <SpecialOfferForm
            header={"Update Special Offer"}
            formData={formData}
            formError={formError}
            handleChange={handleChange}
            handleSubmit={handleSave}
            loading={loading}
            onClose={onClose}
          />
          {apiError && <ApiError>{apiError}</ApiError>}
        </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateFeaturedAds: (input: CreateSpecialOfferInput, special_offer_id: string) =>
    dispatch(updateSpecialOffer(input, special_offer_id)),
   onResetSpecialOffer: () => dispatch(resetSpecialOffer()),
});
export default connect(null, mapDispatchToProps)(HandleUpdateSpecialOffer);
